import React from 'react'

import { useStatus } from '@hooks/status'

import { Pill } from '../../../../components/Pill'

interface IStatusPillProps {
  status: string
}

export function StatusPill({ status }: IStatusPillProps) {
  const {
    getStatusColorById,
    getStatusNameById,
    formatStatus,
    getStatusIdByName,
  } = useStatus()

  const statusId = getStatusIdByName(status)
  const color = getStatusColorById(statusId)
  const statusName = getStatusNameById(statusId)
  const formattedStatus = formatStatus(statusName)

  return <Pill color={color}>{formattedStatus.toLocaleUpperCase()}</Pill>
}
